import { render } from "./MenuIcon.vue?vue&type=template&id=7064abb1&scoped=true"
import script from "./MenuIcon.vue?vue&type=script&lang=js"
export * from "./MenuIcon.vue?vue&type=script&lang=js"

import "./MenuIcon.vue?vue&type=style&index=0&id=7064abb1&scoped=true&lang=css"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7064abb1"]])

export default __exports__